import { createCsvValidator, type CsvValidator, type ValidationResult } from '~/components/general/createCsvValidator';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const MAX_FILE_SIZE_BYTES = 1024 ** 3;

function validate(file: File): Promise<ValidationResult> {
    const { onCorporate } = useCurrentGroup();

    return createCsvValidator({
        maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
        requiredHeadings: ['phone'],
        validateHeading: (heading: string) => {
            if (!onCorporate() && ['marketing', 'transactional'].includes(heading)) {
                return `The ${heading} column is not supported for this import.`;
            }
            return undefined;
        },
    }).validate(file);
}

export const contactCsvValidator: CsvValidator = {
    validate,
    maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
};

export { validate as validateCsvFile };
